import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
// @ts-expect-error canvas-confetti is not typed
import confetti from 'canvas-confetti';
import { Box, Text } from '@streamelements/frontend-ui';

export const Route = createFileRoute('/_authenticated/onboarding/new-setup/_layout/setup-complete/')({
  component: SetupMultistreamingFinishPage,
});

function SetupMultistreamingFinishPage() {
  const confettiCanvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    confetti({
      particleCount: 120,
      spread: 80,
      origin: { y: 1 },
      gravity: 1.3,
      decay: 0.93,
    });
  }, []);

  return (
    <>
      <Box>
        <img src="/partying-face.png" alt="Setup multistreaming finish" style={{ width: 70, height: 'auto' }} />
        <Text.Subtitle weight="bold" css={{ mb: 0, mt: '1rem' }}>
          Woo-hoo!
        </Text.Subtitle>
        <Text.Body
          variant="caption"
          css={{
            color: '$textPrimary70',
            mb: '1rem',
            maxWidth: 280,
            mx: 'auto',
          }}
        >
          You are all set and ready to go. <br /> Just hit{' '}
          <Text.Body weight="bold" as="span" variant="caption" css={{ color: 'inherit' }}>
            “Start Streaming”
          </Text.Body>{' '}
          whenever you are ready to go live!
        </Text.Body>
      </Box>

      <canvas
        ref={confettiCanvasRef}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: 1,
        }}
      />
    </>
  );
}
